import { render, staticRenderFns } from "./mpsview.vue?vue&type=template&id=beaff020&scoped=true&"
import script from "./mpsview.vue?vue&type=script&lang=js&"
export * from "./mpsview.vue?vue&type=script&lang=js&"
import style0 from "./mpsview.vue?vue&type=style&index=0&id=beaff020&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beaff020",
  null
  
)

export default component.exports